<div class="main-container">
  <div class="inner-container">
    <div class="header-contianer">
      <div class="logo-container">
        <img src="https://tripmeld.com/assets/images/TM_Logo.png" class="logo" alt="">
      </div>
    </div>

    <div class="title-container">
      <p class="title">Upload Required Documents For All Passengers</p>
    </div>

    <div class="form-main-container">
      <form class="itinerary-model-content-inner" [formGroup]="visaForm" *ngIf="visaForm">
        <div class="itinerary-model-content">
          <div class="form-container ion-padding-horizontal">
            <div class="bg-light-blue rounded my-1 p-2">
              <!-- Visa item for passenger Item -->
              <div formArrayName="data">
                <div *ngFor="let visa of visasArray().controls; let visaIndex = index" [formGroupName]="visaIndex"
                  class="mb-2">
                  <div class="rounded">
                    <div class="passenger-name">
                      <p class="name mb-1">{{visasArray().at(visaIndex).get('firstName')?.value}}
                        {{visasArray().at(visaIndex).get('lastName')?.value}} <span *ngIf="getVisaStatus(visasArray().at(visaIndex).get('status')?.value)">| Status : {{getVisaStatus(visasArray().at(visaIndex).get('status')?.value)?.name}}</span></p>
                    </div>
                    <div class="passenger-row">
                      <div class="row-item">
                        <div class="passenger-input">
                          <label class="label">Age</label>
                          <div>
                            <p class="value">{{visasArray().at(visaIndex).get('age')?.value || "--"}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="row-item">
                        <div class="passenger-input">
                          <label class="label">Gender</label>
                          <div>
                            <p class="value">{{visasArray().at(visaIndex).get('gender')?.value || "--"}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="row-item">
                        <div class="passenger-input">
                          <label class="label">Nationality</label>
                          <div>
                            <p class="value">{{visasArray().at(visaIndex).get('nationality')?.value || "--"}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="row-item">
                        <div class="passenger-input">
                          <label class="label">Visa Type</label>
                          <div>
                            <p class="value">{{visasArray().at(visaIndex).get('visaType')?.value || "--"}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="row-item">
                        <div class="passenger-input">
                          <label class="label">Applicant Type</label>
                          <div>
                            <p class="value">{{visasArray().at(visaIndex).get('applicantType')?.value || "--"}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <ng-container formArrayName="documents">
                        <div *ngFor="let document of documentsArray(visaIndex).controls; let docIndex = index"
                          [formGroupName]="docIndex">
                          <div class="card-container">
                            <div class="card-item">
                              <p class="document-name">{{docIndex + 1}}. {{document.get('documentName')?.value}}</p>
                              <div class="main-input-container">
                                <div class="input-container">
                                  <label for="" class="label">Document No.</label>
                                  <div>
                                    <input type="text" class="input" formControlName="documentNumber"
                                      placeholder="Enter Document No.">
                                  </div>
                                </div>
                                <div class="input-container">
                                  <label for="" class="label">Valid From</label>
                                  <div>
                                    <app-date-picker formControlName="validFrom"></app-date-picker>
                                  </div>
                                </div>
                                <div class="input-container">
                                  <label for="" class="label">Valid To</label>
                                  <div>
                                    <app-date-picker formControlName="validTo"
                                      [minDate]="document.get('validFrom')?.value"></app-date-picker>
                                  </div>
                                </div>
                                <div class="input-container">
                                  <label for="" class="label">Upload Document</label>
                                  <div>
                                    <div class="table-input mt-2 d-flex">
                                      <label [attr.for]="'visa'+visaIndex+'doc'+docIndex"
                                        class="upload-btn clickable-text"><ion-icon
                                          name="cloud-upload-outline"></ion-icon></label>
                                      <div class="file-view"
                                        *ngIf="documentsArray(visaIndex).at(docIndex).get('document')?.value">
                                        <p class="clickable-text mb-0"
                                          (click)="openAttachment(documentsArray(visaIndex).at(docIndex).get('document')?.value)">
                                          View Document</p>
                                      </div>
                                      <input [attr.id]="'visa'+visaIndex+'doc'+docIndex" type="file" class="d-none"
                                        (change)="onDocumentSelected($event, visaIndex, docIndex)"
                                        accept="image/*,.pdf">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div *ngIf="documentsArray(visaIndex)?.length === 0">
                          <div colspan="7" class="text-center">
                            <p class="my-2">No Documents Selected!</p>
                          </div>
                        </div>
                      </ng-container>

                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>


        </div>

        <div class="ion-padding-horizontal justify-content-center itinerary-model-footer sticky-bottom bg-light">
          <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
            Save
          </ion-button>
        </div>
      </form>



    </div>
  </div>
  <app-spinner *ngIf="showSpinner"></app-spinner>
</div>